export default "__VITE_ASSET__CHf21rM0__"